import React from 'react'
import {Box, Divider} from '@mui/material'
import {Typography} from '../../../webui/Typography'

interface FormSectionProps {
  title: string
  /** Hide the top divider on the first section. */
  first?: boolean
  children: React.ReactNode
}

/**
 * Groups related fields in the edit drawer under a heading, with a divider
 * separating it from the previous section.
 */
export const FormSection: React.FC<FormSectionProps> = ({title, first, children}) => (
  <Box>
    {!first && <Divider sx={{my: 2}} />}
    <Typography variant="overline" color="text.secondary" sx={{letterSpacing: 1}}>
      {title}
    </Typography>
    <Box mt={1}>{children}</Box>
  </Box>
)
